$(document).ready(function(){
     $(document).scroll(function() {
        if ( $(document).scrollTop() >= 1000 ) {
            $('.sticky_button-outer').addClass('visible');
        } else {
            $('.sticky_button-outer').removeClass('visible');
        }
    });

    $('.sticky_button-main').click(function(evt){
        evt.preventDefault();
        $('html, body').animate({
            scrollTop: $("#Details").offset().top
        }, 500);
    });

});